// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__yWg_c","inner":"Footer_inner__1nllj"};